import { Box, Flex, Text } from '@chakra-ui/react';
import { faFileImport } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonText, Modal } from '@morressier/alembic';
import { IReviewAssessment } from '@publishing-engine/domain/types';
import { useState } from 'react';
import RecommendationBadge from 'src/components/RecommendationBadge';
import { SubmissionPhase } from 'src/pages/Organization/Workspace/Submissions';
import { formatDate } from 'src/utils/date';

interface Props {
  items: IReviewAssessment[];
  submissionStatus: string;
}

export const AuthorReviewHistory: React.FC<Props> = ({
  items,
  submissionStatus
}) => {
  const [showModal, setShowModal] = useState(false);

  if (items.length < 2) return null;

  const onClose = () => setShowModal(false);
  return (
    <>
      <ButtonText
        marginTop={2}
        maxWidth="fit-content"
        onClick={() => setShowModal(true)}
      >
        View Review History
      </ButtonText>

      <Modal
        isOpen={showModal}
        closeButtonProps={{
          hidden: true
        }}
        onClose={onClose}
        width="720px"
      >
        <Flex
          padding={8}
          gap={6}
          flexDirection="column"
          maxHeight="80vh"
          overflow="auto"
        >
          <Box>
            <FontAwesomeIcon fontSize={32} icon={faFileImport} />
          </Box>

          <Flex flexDirection="column" gap={2}>
            <Text textStyle="headingGroup">Review History</Text>
          </Flex>

          {items.map(({ submissionManuscriptId, date, recommendation }, i) => {
            const submissionRevisionNo = +submissionManuscriptId?.replace(
              /.*R/,
              ''
            );
            return (
              <Flex flexDirection={'column'} gap={2} key={submissionRevisionNo}>
                <Text textStyle="headingOverline" textTransform="uppercase">
                  {`${
                    submissionRevisionNo === 0
                      ? 'Original Submission '
                      : `Revision -  ${submissionRevisionNo} `
                  }`}
                  (Review sent on {formatDate(new Date(date))})
                </Text>
                <Flex gap={2} marginTop={2} alignItems="center">
                  <Text textStyle="headingItem">Reviewer Recommendation:</Text>
                  <RecommendationBadge recommendation={recommendation} />
                </Flex>
                {i === 0 && (
                  <Flex gap={2} alignItems="center">
                    <Text textStyle="headingItem">Submission Status:</Text>
                    <SubmissionPhase
                      currentState={submissionStatus}
                      isHoverDisabled
                    />
                  </Flex>
                )}
              </Flex>
            );
          })}

          <Flex
            gap={2}
            justifyContent="flex-end"
            alignItems="center"
            alignSelf="stretch"
          >
            <Button
              onClick={onClose}
              variant="primary"
              type="submit"
              borderRadius="small"
            >
              Close
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
};
